export default class JraShowJoin {
  constructor(element) {
    this.element = element;
    this.urlTemplate = this.element.dataset.jraShowJoinUrl;

    this.initJraShowJoin();
  }


  initJraShowJoin() {
    this.modal = this.element.querySelector('[data-jra-show-join-modal]');
    this.openModal = this.element.querySelector('[data-jra-show-join-change-show-button]');
    if (this.openModal) {
      this.openModal.addEventListener('click', this.onOpenModal);
    }

    this.closeModal = this.element.querySelector('[data-jra-show-join-close-button]');
    if (this.closeModal) {
      this.closeModal.addEventListener('click', this.onCloseModal);
    }

    this.submitButton = this.element.querySelector('[data-jra-show-join-submit]');
    this.submitButton.addEventListener('click', this.onSubmitClick);

    this.showRadioButtons = [...this.element.querySelectorAll('[data-jra-show-join-show-radio]')];

    this.clearButton = this.element.querySelector('[data-jra-show-join-clear-button]');
    if (this.clearButton) {
      this.clearButton.addEventListener('click', this.onClearForm);
    }

    this.clearConfirmMessage = this.element.dataset.jraShowJoinClearConfirm || 'Are you sure you want to reset the form?';

    // determine if a show is already selected in the page model
    this.pageSelectedId = this.showRadioButtons
      .reduce((selectedId, radioButton) => {
        if (radioButton.checked) {
          return radioButton.id;
        }
        return selectedId;
      }, undefined);

    // if there is only one show available, preselect this show
    if (this.showRadioButtons.length > 0) {
      this.showRadioButtons.forEach((radioButton, index, array) => {
        radioButton.addEventListener('change', this.onRadioButtonSelect);

        if (array.length === 1) radioButton.checked = true;
        if (radioButton.checked) this.selectedId = radioButton.id;
      });
    }

    // open modal if there is no page selected show
    if (!this.pageSelectedId) {
      this.element.classList.add('JraShowJoin-active');
    } else {
      this.selectedId = this.pageSelectedId;
    }

    this.checkToDisableEnable();
  }


  onSubmitClick = () => {
    if (this.urlTemplate) {
      const url = window.location.href.replace(window.location.search, '');
      const search = this.urlTemplate.replace('{id}', this.selectedId);
      window.location.href = `${url}${search}`;
    }
  }


  onRadioButtonSelect = (event) => {
    const showRadioButton = event.currentTarget;
    if (showRadioButton) {
      this.selectedId = showRadioButton.id;
      this.checkToDisableEnable();
    }
  }


  onOpenModal = () => {
    this.element.classList.add('JraShowJoin-active');
  }


  onCloseModal = () => {
    this.element.classList.remove('JraShowJoin-active');
  }


  onClearForm = () => {
    const okToClear = window.confirm(this.clearConfirmMessage);

    if (okToClear) {
      window.location.href = window.location.href;
    }
  }


  checkToDisableEnable() {
    if (this.pageSelectedId === this.selectedId) {
      this.submitButton.setAttribute('disabled', 'disabled');
    } else {
      this.submitButton.removeAttribute('disabled');
    }
  }
}
